import {ordinalize} from 'vendor';

export function stopPropagation(event: Event) {
  event.stopPropagation();
}

export function preventDefault(event: Event) {
  event.preventDefault();
}

export function returnNull() {
  return null;
}

export function addPx(value: any) {
  return typeof value === 'number' ? Math.round(value).toString() + 'px' : value;
};

export const empty = {};

export const emptyArray = [];

export function ordinalizeOrLast(value: number | string): string {
  if (value === 6 || value === '6') {
    return 'last';
  }
  return ordinalize(value);
}

export const nonNullable = <T>(item: T): item is NonNullable<T> => {
  return Boolean(item);
};
